const mediaData = [
  {
    title: '流浪地球3：太阳系外的希望',
    desc: '中国科幻电影新标杆，视觉特效震撼人心',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20sci-fi%20illustration%20with%20warm%20coral%20and%20deep%20amber%20tones%2C%20abstract%20cosmic%20landscape%20with%20distant%20planet%20and%20glowing%20nebula%2C%20clean%20minimal%20composition%2C%20modern%20flat%20illustration%20style%2C%20no%20text%2C%20cinematic%20mood%2C%20epic%20scale&width=800&height=450&seq=xiaocao-media-1&orientation=landscape',
    duration: '2h 48min',
    rating: '9.2',
  },
  {
    title: '热辣滚烫：重新出发',
    desc: '年度最感人励志喜剧，笑中带泪的温暖故事',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20uplifting%20illustration%20with%20coral%20and%20golden%20tones%2C%20abstract%20urban%20landscape%20at%20sunset%2C%20clean%20minimal%20composition%2C%20modern%20flat%20illustration%20style%2C%20no%20text%2C%20inspiring%20cinematic%20mood%2C%20warm%20atmosphere&width=800&height=450&seq=xiaocao-media-2&orientation=landscape',
    duration: '2h 10min',
    rating: '8.8',
  },
  {
    title: '封神第二部：战火西岐',
    desc: '东方神话史诗巨制，奇幻视效再攀高峰',
    img: 'https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20illustration%20with%20warm%20golden%20and%20coral%20tones%2C%20abstract%20ancient%20Chinese%20mythological%20landscape%2C%20clean%20minimal%20composition%2C%20modern%20flat%20illustration%20style%2C%20no%20text%2C%20cinematic%20atmosphere%2C%20grand%20scale&width=800&height=450&seq=xiaocao-media-3&orientation=landscape',
    duration: '2h 30min',
    rating: '8.5',
  },
  {
    title: '第二十条：正义之名',
    desc: '深度剧情佳作，探讨法与情的边界',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20illustration%20with%20warm%20amber%20and%20soft%20coral%20tones%2C%20abstract%20cityscape%20silhouette%2C%20clean%20minimal%20composition%2C%20modern%20flat%20illustration%20style%2C%20no%20text%2C%20thoughtful%20atmosphere%2C%20refined%20mood&width=800&height=450&seq=xiaocao-media-4&orientation=landscape',
    duration: '2h 20min',
    rating: '9.0',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精彩影音</h2>
          <p className="text-sm text-foreground-500 max-w-[560px] mx-auto">精选高清影视内容，当前热映与口碑佳作一网打尽。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaData.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl bg-background-50 border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500">
                    <i className="ri-play-fill text-2xl"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded text-[10px] font-medium bg-background-950/70 text-background-50">{item.duration}</span>
                <span className="absolute top-2 right-2 px-1.5 py-0.5 rounded text-[10px] font-bold bg-primary-500 text-background-50">{item.rating}</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-1 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}